﻿'use strict'

const footer = {
	init: function () {
		this.el = document.querySelector('.footer')

		if (this.el != null) {
				this.headerButtons = this.el.querySelectorAll('.footer__header')
				this.events()
		}
	},

	events: function () {
		for (let i = 0; i < this.headerButtons.length; i++)
			this.headerButtons[i].addEventListener('click', (e) => this.toggleSubMenu(e))
	},

	toggleSubMenu: function (e) {
		const target = e.currentTarget

		!target.classList.contains('show') ? target.classList.add('show') : target.classList.remove('show')
	}
}

export default footer.init()